module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-anna-shvets-4226140-a316899eaa677239f8c6b4bd68a89cab.jpg";